interface ImageOverlayProps {
  text: string;
}

export function ImageOverlay({ text }: ImageOverlayProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-[#FBEFEF]/70 text-white p-4 cursor-pointer">
      <div className="flex flex-col cursor-pointer">
        <img src="/images/photoshoot.svg" alt="" />
        <p className="text-center text-black pt-3">{text}</p>
        <div className="flex items-center justify-center gap-3">
          <button
            className="text-center text-black pointer"
          >
            View post
          </button>
          <img src="/images/rightblackarrow.svg" alt="" />
        </div>
      </div>
    </div>
  );
}
